import { Moon, Sun } from 'lucide-react';
import { useTheme } from '../theme';
import { useI18n } from '../i18n';

/** Header theme switch — day/night aperture aligned with language chrome. */
export function ThemeSwitcher({ className = '' }: { className?: string }) {
  const { theme, toggleTheme } = useTheme();
  const { t } = useI18n();
  const isDark = theme === 'dark';
  const action = isDark ? t.theme.toLight : t.theme.toDark;

  return (
    <button
      type="button"
      data-cursor
      className={`theme-dial ${className}`.trim()}
      data-mode={theme}
      onClick={toggleTheme}
      role="switch"
      aria-checked={isDark}
      aria-label={action}
      title={action}
    >
      <span className="theme-dial__aperture" aria-hidden>
        <span className="theme-dial__sky" />
        <span className="theme-dial__stars" />
        <Sun className="theme-dial__sun" size={14} strokeWidth={2.25} />
        <Moon className="theme-dial__moon" size={13} strokeWidth={2.25} />
      </span>
      <span className="mono-label theme-dial__status">
        {isDark ? t.theme.dark : t.theme.light}
      </span>
    </button>
  );
}
